import { useTranslation } from "react-i18next"

/**
 * OKS-519 — §13 "· · · N more creators · · ·" divider.
 *
 * Passive, centred, dotted divider shown between the podium and the
 * around-you window when the viewer is far down the board (gap > 0). Non-
 * interactive in v1 (PRD Open Q5 — no expand).
 */
interface GapDividerProps {
  count: number
}

export function GapDivider({ count }: GapDividerProps) {
  const { t } = useTranslation()

  return (
    <div
      data-testid="creator-leaderboard-gap"
      className="text-muted-foreground flex items-center gap-2 px-3 py-1 text-xs"
    >
      <span className="border-muted-foreground/30 flex-1 border-t border-dotted" />
      <span>{t("leaderboard.creator.gap", { count })}</span>
      <span className="border-muted-foreground/30 flex-1 border-t border-dotted" />
    </div>
  )
}
